import styled from 'styled-components'
import { Theme, Button } from '@pga/pga-component-library'

const flipDisplayWidth = 776

export const StyledContainer = styled.div`
  display: flex;
  width: 928px;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  max-height: max-content;
  border: 1px solid ${Theme.colors.pearlGrey};

  background-color: rgba(255,255,255,0.7);
  box-shadow: 0 0 6px 0 rgba(0,0,0,0.07);
  transition:0.2s ease-out;
  overflow: hidden;
  :hover {
    box-shadow: 0px 0px 15px 5px ${Theme.colors.bgGrey};
    
  }
  @media screen and (max-width: ${flipDisplayWidth}px) {
    flex-direction: column-reverse;
  }
`

export const StyledActionSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 41px 45px;
  padding-bottom: 28px;
  width: 60%;
  min-width: 60%;
  @media screen and (max-width: ${flipDisplayWidth}px) {
    width: 100%;
  }
`

export const StyledImgWrapper = styled.div`
  position: relative;
  color: white;
`

export const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const StyledImgText = styled.div`
  position: absolute;
  bottom: 40px;
  left: 15%;

  border-radius: 20px;
  border: 1px solid gray;
  padding: 16px;
  background: rgb(0,35,75, .3);

  @media(max-width: 991.98px) {
    left: 4%;
  }
  @media(max-width: 767.98px) {
    left: 25%;
  }
  @media(max-width: 500.98px) {
    left: 21%;
  }
  @media(max-width: 450.98px) {
    left: 17%;
  }
  @media(max-width: 400.98px) {
    left: 11%;
    padding: 8px;
  }
  @media(max-width: 370.98px) {
    left: 8%;
  }
  @media(max-width: 350.98px) {
    left: 4%;
  }
  p {
    margin: 0;
    margin-top: 8px;
    margin-left: 8px;
    font-size: 16px;
  }
`
export const StyledImgSpanText = styled.span`
  font-size: 10px;
  margin-left: 16px;
`

export const StyledTitle = styled.h3`
  font-size: 30px;
  font-family: ${props => props.theme.fonts.body};
  font-weight: 700;
  line-height: 36px;
  margin-bottom: 24px;
  color: ${props => props.theme.colors.secondary};
`

export const StyledInfo = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 25px;
  margin-bottom: 36px;
  color: ${Theme.colors.blueGrey};
`

export const StyledButton = styled(Button)`
  margin-top: auto;
  width: 100%;
  min-width: 145px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 600;
  font-weight: bold;
  border: none;
  @media screen and (max-width: ${flipDisplayWidth}px) {
    width: 100%;
  }
`

export const StyledLink = styled.a`
  width: 100%;
`

export const StyledSecondaryInfo = styled.div`
  margin-top: 10px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: ${Theme.colors.blueGrey};
`
